/* eslint-disable react/no-array-index-key */
import * as React from 'react';

import { Bone } from '@lightspeed/flame/Bone';
import { Card, CardSection } from '@lightspeed/flame/Card';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Divider } from '@lightspeed/flame/Divider';
import { Text } from '@lightspeed/flame/Text';

import SectionTitle from 'root/apps/PurchaseOrder/ShipmentHistory/components/SectionTitle';

import type { ShipmentsOverview } from 'root/apps/PurchaseOrder/ShipmentHistory/types';

interface Props {
  isLoading: boolean;
  data?: ShipmentsOverview;
}

const Information: React.FC<Props> = ({ isLoading, data }) => {
  return (
    <Box style={{ margin: '36px 0', width: '100%' }}>
      <Flex justifyContent="space-between">
        {!isLoading ? (
          <SectionTitle>Order information</SectionTitle>
        ) : (
          <Box>
            <Bone height={4} width="150px" />
          </Box>
        )}
        <Card style={{ flex: 2, maxWidth: '60%' }}>
          {isLoading ? (
            new Array(3).fill(0).map((_v, index, row) => (
              <React.Fragment key={index}>
                <CardSection style={{ padding: '1rem' }}>
                  <Flex>
                    <Bone height={3} width="30%" style={{ marginRight: '15%' }} />
                    <Bone height={3} width="30%" />
                  </Flex>
                </CardSection>
                {index + 1 !== row.length ? <Divider /> : null}
              </React.Fragment>
            ))
          ) : (
            <>
              <CardSection style={{ padding: '1rem' }}>
                <Flex>
                  <Text fontWeight={700} style={{ width: '35%' }}>
                    PO number
                  </Text>
                  <Text className="notranslate">{data?.orderID || '-'}</Text>
                </Flex>
              </CardSection>
              <Divider />
              <CardSection style={{ padding: '1rem' }}>
                <Flex>
                  <Text fontWeight={700} style={{ width: '35%' }}>
                    Vendor
                  </Text>
                  <Text className="notranslate" style={{ width: '65%' }}>
                    {data?.vendorName || '-'}
                  </Text>
                </Flex>
              </CardSection>
              <Divider />
              <CardSection style={{ padding: '1rem' }}>
                <Flex>
                  <Text fontWeight={700} style={{ width: '35%' }}>
                    Reference number
                  </Text>
                  <Text className="notranslate" style={{ width: '65%' }}>
                    {data?.refNum || '-'}
                  </Text>
                </Flex>
              </CardSection>
            </>
          )}
        </Card>
      </Flex>
    </Box>
  );
};

export default Information;
